import { useSelector } from 'react-redux';

import { onApplicationLogout } from 'common/api/index';
import {
	DEFAULT_API_VERSION,
	DEFAULT_TENANT_ID,
	MODULES,
} from 'common/constants';
import { HTTP_STATUS_CODES } from 'common/constants/HttpStatusConstants';
import localStorageWrapper from 'common/loginUtils/local-storage-wrapper';
import storageWrapper from 'common/loginUtils/storage-wrapper';
import { RootState } from 'common/store/AppStore';

import { deleteAIGeneratedCards } from 'features/RiskProfile/Taxonomy/api';
import { IRenegerateChanges } from 'features/RiskProfile/Taxonomy/api/type-def';

export const isRoleExists = (role: string[] | string) => {
	const loggedInUser = useSelector(
		(state: RootState) => state.common.loggedInUser,
	);
	const userRole = loggedInUser?.roles || [];
	if (!!role && role.constructor === Array) {
		const retundata = userRole.some((element) =>
			role.includes(element.roleName),
		);
		return retundata;
	}

	return userRole.some((element) => element.roleName === role);
};

export const isGroupExists = (group: string[] | string) => {
	const loggedInUser = useSelector(
		(state: RootState) => state.common.loggedInUser,
	);
	const userRole = loggedInUser?.groups || [];
	if (!!group && group.constructor === Array) {
		const retundata = userRole.some((element) =>
			group.includes(element.groupName),
		);
		return retundata;
	}
	return userRole.some((element) => element.groupName === group);
};

export const isModuleExists = (module: string[] | string) => {
	const loggedInUser = useSelector(
		(state: RootState) => state.common.loggedInUser,
	);
	const modules = loggedInUser?.modulePermissions || [];
	if (!!modules && modules.constructor === Array) {
		const retundata =
			modules.some((element) => module.includes(element.moduleName)) ||
			module.includes(MODULES.HOME);
		return retundata;
	}
	return (
		modules.some((element) => element.moduleName === module) ||
		module === MODULES.HOME
	);
};

const logoutWithOpenWidow = (tenantId: string, ssoType: string) => {
	const { REACT_APP_LOGOUT_URL, REACT_APP_SSO_LOGOUT_URL } = process.env;
	const ENV_LOGOUT_URL =
		ssoType === 'v1' ? REACT_APP_LOGOUT_URL : REACT_APP_SSO_LOGOUT_URL;
	const isAzure = ENV_LOGOUT_URL?.includes('microsoftonline');
	const azureLogoutTime = 7000;
	const oktaLogoutTime = 1000;
	const timeInterval = isAzure ? azureLogoutTime : oktaLogoutTime;
	const baseUrl = window.location.origin;
	const logoutUrl = `${ENV_LOGOUT_URL}${baseUrl}`;
	const logoutWindow = window.open(logoutUrl, '_blank'); // Open window with the URL of the current page
	setTimeout(() => {
		logoutWindow?.close();
		window.location.href = `${baseUrl}/${tenantId}`;
	}, timeInterval);
};

export const storageCleanAndRedirect = async (status?: number) => {
	const { UNAUTHORIZED } = HTTP_STATUS_CODES;
	const tenantId =
		localStorageWrapper.getStorageItem('tenantId') || DEFAULT_TENANT_ID;
	const ssoType =
		localStorageWrapper.getStorageItem('ssoType') || DEFAULT_API_VERSION;
	storageWrapper.clearStorage(); // Assuming storageWrapper is correctly imported and accessible
	localStorageWrapper.clearStorage();
	if (status === UNAUTHORIZED) {
		logoutWithOpenWidow(DEFAULT_TENANT_ID, ssoType);
		return;
	}
	logoutWithOpenWidow(tenantId, ssoType);
};
export const onLogout = async (
	deleteAIGeneratedCardPayload?: IRenegerateChanges,
	isRegenerateMappingBtnClicked?: boolean,
) => {
	try {
		if (isRegenerateMappingBtnClicked) {
			await deleteAIGeneratedCards(
				deleteAIGeneratedCardPayload?.parentObjectId,
				deleteAIGeneratedCardPayload,
			);
		}
		await onApplicationLogout();
	} finally {
		storageCleanAndRedirect();
	}
};
